var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "13px",
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livesubs-5-Copy",
    transform: "translate(-628.000000, -215.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(622.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round-compare_arrows-24px",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.01,14.5662686 L3,14.5662686 C2.45,14.5662686 2,15.031179 2,15.5994029 C2,16.1676268 2.45,16.6325372 3,16.6325372 L9.01,16.6325372 L9.01,18.4818476 C9.01,18.946758 9.55,19.1740476 9.86,18.8434446 L12.64,15.9609999 C12.83,15.754373 12.83,15.4341014 12.64,15.2274746 L9.86,12.3450299 C9.55,12.0144269 9.01,12.2520478 9.01,12.7066269 L9.01,14.5662686 Z M14.99,12.2830418 L14.99,10.4337314 L21,10.4337314 C21.55,10.4337314 22,9.96882097 22,9.4005971 C22,8.83237324 21.55,8.3674628 21,8.3674628 L14.99,8.3674628 L14.99,6.5181524 C14.99,6.05324197 14.45,5.82595242 14.14,6.1565554 L11.36,9.0390001 C11.17,9.24562696 11.17,9.56589859 11.36,9.77252545 L14.14,12.6549701 C14.45,12.9752418 14.99,12.7479522 14.99,12.2830418 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSwitch);
export default __webpack_public_path__ + "static/media/ic-switch.81df616d963078ab2a553cc2b5846586.svg";
export { ForwardRef as ReactComponent };